import { createModelPermissions } from "components/permissions/utils/model-permission-generator";

const teamBasePath = "/teams";

const TeamConst = createModelPermissions({
  modelName: "teams",
  basePath: teamBasePath,
  permissions: {
    VIEW: true,
    UPDATE: true,
    DELETE: true,
    EDIT: true,
  },
});

export default TeamConst;
